import React, {Component} from 'react';
import {Form, FormGroup, Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import Notify from 'react-notification-alert';
import {showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import AuthModulesTabView from "./AuthModulesTabView";
import Alert from "react-s-alert";


class AuthRoleCreateModal extends Component {

	constructor(props) {
		super(props)
		this.state =
			{
				alert:null,
				saving: false,
				activeTab: null,
				modal: false,
				roleName: "",
				modules: []
			};

		this.save = this.save.bind(this);
		this.toggleModal = this.toggleModal.bind(this);
		this.toggleTab = this.toggleTab.bind(this);
		this.setAuthModule = this.setAuthModule.bind(this);
	}

	componentDidMount() {

		this.fetchData(undefined, undefined, undefined, undefined)
	}

	fetchData(accessor, direction, page, size) {
		let self = this;

		let params = {
			url: `/user/fetchRoles`,
			method: "get",
		};
		self.setState({loading: true});
		request(params)
			.then(function (response) {
				let roles = response.data.roles;
				let modules = roles.modules;
				self.setState({
					modules: modules ? modules : [],
					activeTab: modules ? modules[0].id : null,
					loading: false,
				});
			}).catch(function (error) {
			self.setState({loading: false});
			showAxiosError(error);
		});
	}

	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	toggleModal() {
		this.props.listener();
	}

	save() {
		let self = this;
		let {modules, roleName} = this.state;
		let errorMessage = "", showError = false;

		if(modules && modules.length === 0 )
			return;

		if (!roleName) {
			errorMessage = "Yetki Grubu Adı boş bırakılamaz.";
			showError = true;
		}

		if (showError) {
			this.refs.notify.notificationAlert({
				place: 'tr',
				message: errorMessage,
				type: 'danger',
				autoDismiss: 5,
			});
			return;
		}

		let params = this.createRequestParams();

		this.setState({saving: true});

		request(params)
			.then(function (response) {

				Alert.success("Kaydedildi", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000
				});
				self.props.listener();

		}).catch(function (error) {
			self.setState({saving: false});
			if (error.response && error.response.status === 422) {
				self.refs.notify.notificationAlert({
					place: 'tr',
					message: error.response.data.Exception,
					type: 'danger',
					autoDismiss: 5,
				});
			}
			else showAxiosError(error);
		});
	}

	createRequestParams() {

		let data = {}
		data.name = this.state.roleName
		data.modules = this.state.modules

		let params = {
			url: "/user/createRole",
			method: 'post',
			data: data
		};

		return params;
	}

	setAuthModule(value, i, j) {
		let {modules} = this.state;
		if (i === undefined && j === undefined) {
			this.setState({roleName: value})
		} else {
			modules[i]["privileges"][j].selected = value;
			this.setState({modules})
		}
	}


	render() {

		let {modules, activeTab, roleName} = this.state;
		return (
			<Modal isOpen={this.props.modal} size="lg">
				<Notify ref="notify"/>
				{this.state.alert}
				<ModalHeader toggle={this.toggleModal}>Yetki Grubu Oluştur</ModalHeader>
				<ModalBody>
					{this.state.loading &&
					<div className="row col-sm-12"><span className="pull-right"><i className="fa fa-spinner fa-spin"/>Yükleniyor..</span></div>}
					{this.state.saving &&
					<div className="row col-sm-12" style={{backgroundColor:'#bbd7ea'}}><span style={{color:'white'}} className="pull-right">İşleniyor..</span></div>}
					{(modules && modules.length === 0) &&
						<h4>Aktif hizmetiniz olmadığı için yetki tanımlaması
							yapamazsınız.</h4>
					}
					{(modules && modules.length > 0) &&
					<Form>
						<FormGroup row>
							<AuthModulesTabView modules={modules}
												activeTab={activeTab}
												roleName={roleName}
												tabListener={this.toggleTab}
												showSaveButton={false}
												listener={this.setAuthModule}
							/>
						</FormGroup>
					</Form>
					}
				</ModalBody>
				<ModalFooter>
					<div className="col-sm-2">
					<button type="button"  disabled={this.state.saving}  onClick={this.toggleModal}
							style={{background: ' linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))', padding:'8px 45px 8px 16px'}}
							className=" TekBtn vazgec">Kapat
					</button>
					</div>
					<div className="col-sm-8"></div>
					<div className="col-sm-2">
					<button type="button" style={{ padding:'8px 45px 8px 16px'}} disabled={this.state.saving || modules.length === 0} onClick={this.save} className="  TekBtn kaydet pull-right ">Kaydet
					</button>
					</div>
				</ModalFooter>
			</Modal>
		)
	}
}

export default AuthRoleCreateModal;